__turbopack_context__.v({
  "componentIcon": "SearchBarAutocomplete-module-scss-module__xJARVq__componentIcon",
  "dropdown": "SearchBarAutocomplete-module-scss-module__xJARVq__dropdown",
  "icon": "SearchBarAutocomplete-module-scss-module__xJARVq__icon",
});
